import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SignupService } from './user.service';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { PropertyService } from '../properties/service/property.service';
import { MessageService } from 'primeng/api';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { usPhoneValidator } from '../../core/shared/validators/us-phone.validator';
import { PhoneUtils } from '../../core/shared/utils/phone.utils';
@Component({
  selector: 'app-create-user',
  standalone: true,
  imports: [ButtonModule, ReactiveFormsModule, CommonModule, InputTextModule, FormsModule, DropdownModule, TableModule, DialogModule, ToastModule, NgxMaskDirective, TooltipModule],
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss'],
  providers: [MessageService, provideNgxMask()]
})
export class CreateUserComponent {
  @Input() userData: any | null = null;
  @Output() closeDialog = new EventEmitter<void>();
  position: 'center' | 'right' = 'center';
  visible: boolean = false;
  userdata: any;
  signupForm: FormGroup;
  showPassword = false;
  isActive: any[] = [
    { label: 'Active', value: true },
    { label: 'InActive', value: false }
  ];

  get isLandlord(): boolean {
    return this.userData?.user_type === 'landlord';
  }

  get availableUserTypes(): any[] {
    return [{ label: 'Admin', value: 'admin' }];
  }

  constructor(private fb: FormBuilder, private createUserService: PropertyService, private messageService: MessageService) {
    this.signupForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: [''],
      user_type: ['admin', Validators.required],
      //phone: ['+1', [Validators.required, Validators.maxLength(16), Validators.pattern(/^\+1\d{10,15}$/)]],
      phone: ['', [Validators.required, usPhoneValidator]], // US format xxx-xxx-xxxx
      isActive: [null],
    });
  }

  ngOnInit(): void {
    if (this.userData) {
      let phone = this.userData.phone || '';
      if (phone && phone.startsWith('1')) {
        phone = phone.substring(1);
      } else if (phone.startsWith('+1')) {
        phone = phone.substring(2);
      }
      this.signupForm.patchValue({
        email: this.userData.email,
        first_name: this.userData.first_name,
        last_name: this.userData.last_name,
        phone: phone,
        isActive: this.userData.isActive,
        user_type: 'admin',
      });

      if (this.isLandlord) {
        this.signupForm.get('email')?.disable();
        this.signupForm.get('isActive')?.disable();
        this.signupForm.get('user_type')?.disable();
      }
    }
  }

  onSubmit(): void {
    if (this.signupForm.valid) {
      const userPayload = this.signupForm.getRawValue();
      userPayload.phone = PhoneUtils.toE164(userPayload.phone);
      console.log('User Payload:', userPayload);
      if (this.userData) {
        this.updateTenant(userPayload);
      } else {
        this.createTenant(userPayload);
      }
    } else {
      console.error('Form is invalid');
    }
  }

  createTenant(userPayload: any): void {
    this.createUserService.createUser(userPayload).subscribe(
      (response) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'User created successfully!',
        });
        this.closeDialog.emit();
      },
      (error) => {
        console.error('Error creating user:', error);
        const errorMessage = error?.error?.message || 'Failed to create user!';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: errorMessage,
        });
      }
    );
  }

  updateTenant(userPayload: any): void {
    if (this.userData && this.userData._id) {
      this.createUserService.updateUser(this.userData._id, userPayload).subscribe(
        (response) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'User updated successfully!',
          });
          this.closeDialog.emit();
        },
        (error) => {
          console.error('Error updating user:', error);
          const errorMessage = error?.error?.message || 'Failed to update user!';
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: errorMessage,
          });
        }
      );
    }
  }



  // onSubmit(): void {
  //   if (this.signupForm.valid) {
  //     this.createUserService.createUser(this.signupForm.value).subscribe(
  //       response => {
  //         console.log('Registration successful:', response);
  //       },
  //       error => {
  //         console.error('Registration failed:', error);
  //       }
  //     );
  //   }
  // }


  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }


  enforcePrefix(event: any) {
    const phoneCtrl = this.signupForm.get('phone');
    const input: HTMLInputElement = event.target; // actual input element

    if (phoneCtrl) {
      let val: string = phoneCtrl.value || '';

      // Always enforce +1 prefix
      if (!val.startsWith('+1')) {
        val = '+1' + val.replace(/^\+?1?/, '');
      }

      // Remove all non-digits after +1
      //console.log('Before formatting:', val);
      val = '+1' + val.substring(2).replace(/\D/g, '');

      // console.log('After formatting:', val);
      // console.log('Value length:', val.length);
      // Update value
      phoneCtrl.setValue(val, { emitEvent: false });

      // Force cursor to end (fixes numpad typing issue too)
      requestAnimationFrame(() => {
        input.selectionStart = input.selectionEnd = val.length;
      });
    }
  }
}
